import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

export interface ArchivedItem {
  name: string;
  type: 'area' | 'field';
}

export interface PublishPreview {
  areas?: AreaChangePreview[];
  added: string[];
  removed: string[];
  modified: string[];
  archived: ArchivedItem[];
  hasChanges: boolean;
}

export interface AreaChangePreview {
  areaId: string;
  name: string;
  status?: 'added' | 'removed' | 'modified';
  added: string[];
  removed: string[];
  modified: string[];
  children: AreaChangePreview[];
}

@Component({
  standalone: false,
  selector: 'app-publish-preview-modal',
  templateUrl: './publish-preview-modal.component.html',
  styleUrls: ['./publish-preview-modal.component.scss'],
})
export class PublishPreviewModalComponent {
  @Input() preview!: PublishPreview;
  @Input() rootName = '';

  constructor(private modalController: ModalController) {}

  cancel() {
    this.modalController.dismiss(false);
  }

  confirm() {
    if (!this.preview.hasChanges) return;
    this.modalController.dismiss(true);
  }
}
